export const mapUnixDateToLocaleDate = (unixDate) => {        
    const options = { year: "numeric", month: "2-digit", day: "2-digit" }    
    return unixDate && new Date(unixDate).toLocaleDateString('en-CA', options);    
};
